import Comment from './Comment'
import Document from './Document'
import Link from './Link'
import TrackedBill from './TrackedBill'
import User from './User'
export default class Notification {
  constructor(objIn = {}) {
    const defaults = {
      //ID is required
      ID: 0,
      //TrackedBillID is required
      TrackedBillID: 0,
      //UserID is required
      UserID: 0,
      CommentID: null,
      LinkID: null,
      DocumentID: null,
      //CreatedDate is required
      CreatedDate: new Date().toISOString().split('T')[0],
      //EmailSent is required
      EmailSent: false,
      //IsAcknowledged is required
      IsAcknowledged: false,
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.ID = obj.ID
    this.TrackedBillID = obj.TrackedBillID
    this.UserID = obj.UserID
    this.CommentID = obj.CommentID
    this.LinkID = obj.LinkID
    this.DocumentID = obj.DocumentID
    this.CreatedDate = obj.CreatedDate
    this.EmailSent = obj.EmailSent
    this.IsAcknowledged = obj.IsAcknowledged
    this.Comment = new Comment(obj.Comment || {})
    this.Document = new Document(obj.Document || {})
    this.Link = new Link(obj.Link || {})
    this.TrackedBill = new TrackedBill(obj.TrackedBill || {})
    this.User = new User(obj.User || {})
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.Comment = null
    obj.Document = null
    obj.Link = null
    obj.TrackedBill = null
    obj.User = null
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.Comment = null
    obj.Document = null
    obj.Link = null
    obj.TrackedBill = null
    obj.User = null
    return obj
  }
}
